
import API from './API';

const ObjetoPostalService = {

	registrarRecebimento: async (obj) => await API.add(`${obj.processo}/objetosPostais/${obj.numero}/registrarRecebimento`, obj),
  registrarArmazenamento: async (obj) => await API.put(`${obj.processoId}/objetosPostais/${obj.objetoPostalId}/registrarArmazenamento`, obj),
  registrarTriagem: async (processo, envelope) => await API.add(`${processo}/objetosPostais/registrarTriagem`, envelope),
	registrarContagem: async (processo, envelope) => await API.add(`${processo}/objetosPostais/registrarContagem`, envelope),
	registrarRecontagem: async (processo, envelope) => await API.add(`${processo}/objetosPostais/registrarRecontagem`, envelope),

  filtrar: async (processo, filtros) => await API.filters(`${processo}/objetosPostais`, filtros),
	listar: async (processo) => await API.list(`${processo}/objetosPostais`),
	getByNumero: async (processo, numero) => await API.find(`${processo}/objetosPostais`, numero),

	atualizarCaixa: async (obj) => await API.put(`${obj.processo}/objetosPostais/${obj.numero}/caixa`,obj),

	visualizarOutrosDocumentos: async (processo, idDE) => await API.download(`${processo}/objetosPostais/outrosDocumentos/${idDE}/visualizar`),

 	registrarPendencias : async (processo, envelope) => await API.add(`${processo}/objetosPostais/registrarPendencias`, envelope),
 	incluirEscola : async (processo, envelope,json) => await API.add(`${processo}/objetosPostais/${envelope}/escolas`, json),
 	editar: async (processo, id, envelope) => await API.edit(`${processo}/objetosPostais`, id, envelope),
  excluir: async (processo, id) => await API.remove(`${processo}/objetosPostais`, id),
	imprimirEtiqueta: async (processo, codigoInep) => await API.download(`${processo}/objetosPostais/${codigoInep}/etiqueta`),
	getByProcessoAndNumeroObjetoPostal: async (processo, numeroObjetoPostal) => await API.get(`${processo}/objetosPostais/${numeroObjetoPostal}`),
	downloadDE: async (processo, idDE) => await API.download(`${processo}/objetosPostais/de/${idDE}/arquivo`),
	finalizar: async (processo, id) => await API.put(`${processo}/objetosPostais/${id}/finalizar`, {}),
	reinicializar: async (processo, id) => await API.add(`${processo}/objetosPostais/${id}/reinicializar`, {}),
  atualizarContagensNoLancamento: async (processo, id,json) => await API.put(`${processo}/objetosPostais/${id}/contagens/lancamento`, json),

  getDadosGraficosObjetoPostais: async (processo) => await API.get(`${processo}/objetosPostais/graficosObjetosPostais`),
  getDadosGraficosCartoes: async (processo) => await API.get(`${processo}/objetosPostais/graficosCartoes`)

}

export default ObjetoPostalService;
